import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['../assets/css/auth.css', './register.component.css']
})
export class RegisterComponent implements OnInit {

  /** Indica se o conteúdo do campo de senha deve ser exibido ou não. */
  private passwordHidden: boolean = true;

  /** Indica se o spinner de carregamento deve ser exibido ou não. */
  private loading: boolean = false;

  /** Conteúdo da mensagem de erro de autenticação. */
  private errorMsg: string = '';

  /** Formgroup com campos de e-mail e senha. */
  loginForm = this.fb.group({
    'secretKey': ['', Validators.required],
    'email': ['', [Validators.required, Validators.email]],
    'password': ['', Validators.required],
    'passwordConfirm': ['', Validators.required],
  });

  /**
   * Construtor
   * @param authService serviço com funções de autenticação.
   * @param fb form builder para os campos de autenticação.
   * @param router router para navegar após autenticação bem sucedida.
   */
  constructor(private authService: AuthService, private fb: FormBuilder, private router: Router) { }

  ngOnInit(): void {
  }

  /**
   * Trata o envio do formulário de cadastro.
   */
  async register() {
    
    let { secretKey, email, password, passwordConfirm } = this.loginForm.value;

    if (password != passwordConfirm) {
      this.errorMsg = 'Os campos de senha não coincidem';
      return;
    }
    
    this.loading = true;
    try {
      let result = await this.authService.register(secretKey, email, password).toPromise();
      this.loading = false;

      if (result.success === true) {
        this.authService.setUserInfo(result.data);
        this.router.navigate(['/sistema/dashboard']);
      }
      else {
        this.errorMsg = result.message;
      }
    }
    catch (err: any) {
      this.loading = false;
      this.errorMsg = err.error.message;
    }
  }

}
